// extracted by mini-css-extract-plugin
export var banner = "_2s-0";
export var icon = "_2s-1";
export var message = "_2s-2";